import React from "react";
import Header from "../master/Header";
import Footer from "../master/Fotter";
import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <>
      <Header />
      <main style={{ marginTop:"107px"}}>
        <Outlet />
      </main>
      <Footer />
    </>
  );
};
export default Layout;
